import { AutoMap } from "@automapper/classes";

export class MeasureMassifDTO {
    @AutoMap()
    code!: string;
    @AutoMap()
    samplingTime!: string;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    samplingId!: number;
    @AutoMap()
    scolaMaterial!: string;
    @AutoMap()
    prelevementEffectue!: boolean;
    @AutoMap()
    sampleCode?: string;
}